/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DatetimeInterval,
    DatetimeIntervalFromJSON,
    DatetimeIntervalFromJSONTyped,
    DatetimeIntervalToJSON,
} from './DatetimeInterval';

/**
 * 
 * @export
 * @interface MovementByBoundaryRequestBody
 */
export interface MovementByBoundaryRequestBody {
    /**
     * 
     * @type {number}
     * @memberof MovementByBoundaryRequestBody
     */
    locality: number;
    /**
     * 
     * @type {Array<DatetimeInterval>}
     * @memberof MovementByBoundaryRequestBody
     */
    intervals: Array<DatetimeInterval>;
}

export function MovementByBoundaryRequestBodyFromJSON(json: any): MovementByBoundaryRequestBody {
    return MovementByBoundaryRequestBodyFromJSONTyped(json, false);
}

export function MovementByBoundaryRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MovementByBoundaryRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locality': json['locality'],
        'intervals': ((json['intervals'] as Array<any>).map(DatetimeIntervalFromJSON)),
    };
}

export function MovementByBoundaryRequestBodyToJSON(value?: MovementByBoundaryRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locality': value.locality,
        'intervals': ((value.intervals as Array<any>).map(DatetimeIntervalToJSON)),
    };
}

